import { render, staticRenderFns } from "./cpt-iframe.vue?vue&type=template&id=4222ccb4&scoped=true"
import script from "./cpt-iframe.vue?vue&type=script&lang=js"
export * from "./cpt-iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222ccb4",
  null
  
)

export default component.exports